import actionTypes from "../actionTypes";
import axios from "axios";
import constants from "../../utils/constants";
import { deleteEmptyProps } from "../../toolkit/utils/filter-utils";
import FileDownload from "js-file-download";
import { errorNotification } from "../../utils/notifications";

const BASE_URL = `${constants.BASE_URL}/api/comisiones`;

export const clearComision = () => ({
  type: actionTypes.CLEAR_COMISION
});

export const getComisionesPagadas = (idEmpleado: number, fechaPago: string) => {
  return {
    type: actionTypes.GET_COMISION_PAGADAS,
    payload: axios.get(`${BASE_URL}/pagadas-por-periodo`, {
      params: deleteEmptyProps({ idEmpleado, fechaPago }),
      withCredentials: true
    })
  };
};

export const downloadComisionesPagadasCSV = (
  idEmpleado: number,
  fechaPago: string,
  callback?: () => void
) => {
  axios
    .get(`${BASE_URL}/pagadas-por-periodo/descargar`, {
      params: deleteEmptyProps({ idEmpleado, fechaPago }),
      withCredentials: true,
      responseType: "blob"
    })
    .then(({ data }) => {
      FileDownload(data, `ComisionesPagadas_${fechaPago}.csv`);
      if (callback) callback();
    })
    .catch(error => {
      errorNotification("Error al descargar CSV");
      console.error(error);
    });
};
